<template>
  <div class="modal-center">
    <travel-person-often :order_add_info="order_add_info" v-if="show_often"></travel-person-often>
    <travel-person-update
      :order_add_info="order_add_info"
      :order_contract_info="order_contract_info"
      :travel_person_id="travel_person_id"
      v-if="!show_often"
    ></travel-person-update>
  </div>
</template>
<script>
import TravelPersonOften from '@/pages/customer/travel_person/travelPersonOften.vue'
import TravelPersonUpdate from '@/pages/customer/travel_person/travelPersonUpdate.vue'
export default {
  name: 'TravelPerson',
  componentName: 'TravelPerson',
  components: {
    TravelPersonOften,
    TravelPersonUpdate
  },
  data () {
    return {
      show_often: true,
      travel_person_id: 0,
    }
  },
  props: {
    order_add_info: Object,
    order_contract_info: Object,
  },
  created () {
    //切换选择/新建 办签人页面的事件
    this.$on('cut.travel.person', this.cut)
  },
  methods: {
    cut (params) {
      if (params.travel_person_id) {
        this.travel_person_id = params.travel_person_id
      } else {
        this.travel_person_id = 0
      }
      this.show_often = params.show_often
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/customer/travel_person/travelPerson.vue